import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/NewButton';

interface DeleteChatDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  chatTitle?: string;
}

export const DeleteChatDialog: React.FC<DeleteChatDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  chatTitle,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="sm:max-w-[400px]" hideCloseButton>
        <DialogHeader>
          <DialogTitle>Delete chat</DialogTitle>
          <DialogDescription>
            {chatTitle
              ? <>This will permanently delete “{chatTitle}”. This cannot be undone.</>
              : <>This will permanently delete this chat. This cannot be undone.</>}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" text="Cancel" onClick={onClose} />
          <Button variant="destructive" text="Delete" onClick={onConfirm} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteChatDialog;
